import { isDevelopment } from 'Douleutaras/constants/system';

/**
 * Logs all actions and states after they are dispatched.
 */
export const logger = store => next => action => {
  // Log error
  if (action.type.indexOf('rejected') !== -1 && isDevelopment) {
    console.group(`%c ${action.type}`, 'background: red; color: #FFFFFF');
    console.error('dispatching', action);
    // tslint:disable-next-line:no-console
    console.log('next state', store.getState());
    console.groupEnd();
  }

  return next(action);
};
